var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53705 12.0696H6.53678C5.30638 12.0702 4.11087 11.6607 3.13921 10.9057L2.83244 11.3006L3.13921 10.9057C0.725669 9.03051 0.289034 5.55345 2.16399 3.1395C4.03891 0.725608 7.51529 0.288961 9.92879 2.16414C12.3423 4.03935 12.779 7.51641 10.904 9.93036L10.6334 10.2787L10.9453 10.5906L14.9319 14.5778C15.0234 14.675 15.0227 14.8272 14.9297 14.9235L14.9297 14.9236C14.8344 15.0222 14.6777 15.0257 14.578 14.9319L10.5914 10.9447L10.2791 10.6323L9.9306 10.9038C8.96068 11.6594 7.76645 12.0696 6.53705 12.0696ZM2.97723 2.97522C2.9772 2.97525 2.97717 2.97529 2.97714 2.97532L2.95307 2.99939L2.95251 2.99995C1.00029 4.9668 1.01167 8.14391 2.97782 10.0967C4.94399 12.0625 8.13122 12.0622 10.0971 10.096C12.0631 8.12963 12.0631 4.94159 10.097 2.97525C8.13094 1.00889 4.94332 1.0089 2.97723 2.97522Z",
    stroke: "#303030"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3d31e914.svg";
export { ForwardRef as ReactComponent };